var _g, _path, _path2, _path3, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_126",
    "data-name": "Group 126",
    xmlns: "http://www.w3.org/2000/svg",
    width: 168.335,
    height: 168.567,
    viewBox: "0 0 168.335 168.567",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flat",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2513",
    "data-name": "Path 2513",
    d: "M172.907,119.872a2.886,2.886,0,0,1-2.848-2.558l-3.6-29.005a2.9,2.9,0,1,1,5.754-.756h0l3.6,29.005a2.967,2.967,0,0,1-2.5,3.255h-.349Z",
    transform: "translate(-19.104 -47.04)",
    fill: "#c4d5df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2514",
    "data-name": "Path 2514",
    d: "M168.056,132.207a2.878,2.878,0,0,1-2.906-2.906,2.359,2.359,0,0,1,.232-1.1l13.66-32.028a2.877,2.877,0,1,1,5.289,2.267h0l-13.66,32.028A2.937,2.937,0,0,1,168,132.207Z",
    transform: "translate(-25.239 -1.829)",
    fill: "#c4d5df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2515",
    "data-name": "Path 2515",
    d: "M190.066,110.313h-30.11a2.906,2.906,0,0,1,0-5.813h30.11a2.906,2.906,0,0,1,0,5.813Z",
    transform: "translate(-64.222 46.687)",
    fill: "#c4d5df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2516",
    "data-name": "Path 2516",
    d: "M152.263,123.99a2.865,2.865,0,0,1-2.79-2.209l-5.813-23.192a2.888,2.888,0,0,1,2.151-3.488,2.925,2.925,0,0,1,3.488,2.093l5.813,23.193a2.94,2.94,0,0,1-2.093,3.546c-.232,0-.465.058-.7.058h0Z",
    transform: "translate(-129.013 1.099)",
    fill: "#c4d5df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2517",
    "data-name": "Path 2517",
    d: "M151.476,95.025a2.878,2.878,0,0,1-2.906-2.906,2.827,2.827,0,0,1,1.976-2.732l26.1-8.719a2.914,2.914,0,0,1,1.86,5.522l-26.1,8.719a2.41,2.41,0,0,1-.93.174h0Z",
    transform: "translate(-105.033 -68.636)",
    fill: "#c4d5df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2518",
    "data-name": "Path 2518",
    d: "M181.836,98.333h-17.38a2.906,2.906,0,1,1,0-5.813h17.38a2.906,2.906,0,0,1,0,5.813Z",
    transform: "translate(-42.565 -10.968)",
    fill: "#c4d5df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2519",
    "data-name": "Path 2519",
    d: "M157.966,108.639a2.878,2.878,0,0,1-2.906-2.906V85.446a2.906,2.906,0,0,1,5.813,0v20.286A2.878,2.878,0,0,1,157.966,108.639Z",
    transform: "translate(-73.799 -58.999)",
    fill: "#c4d5df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2520",
    "data-name": "Path 2520",
    d: "M172.893,113.3a2.727,2.727,0,0,1-2.034-.872L147.666,89.233a2.918,2.918,0,0,1,4.127-4.127L174.985,108.3a2.936,2.936,0,0,1-2.034,5h0Z",
    transform: "translate(-113.371 -50.637)",
    fill: "#c4d5df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2521",
    "data-name": "Path 2521",
    d: "M165.866,98.333h-17.38a2.906,2.906,0,0,1,0-5.813h17.38a2.906,2.906,0,0,1,0,5.813Z",
    transform: "translate(-119.423 -10.968)",
    fill: "#c4d5df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2522",
    "data-name": "Path 2522",
    d: "M149.976,123.073a2.878,2.878,0,0,1-2.906-2.906,2.727,2.727,0,0,1,.872-2.034l20.286-20.286a2.984,2.984,0,0,1,4.127,0,2.929,2.929,0,0,1,0,4.127l-20.286,20.286a2.96,2.96,0,0,1-2.034.872h0Z",
    transform: "translate(-112.252 10.677)",
    fill: "#c4d5df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2523",
    "data-name": "Path 2523",
    d: "M184.286,124.708a2.727,2.727,0,0,1-2.034-.872L160.4,101.981a2.984,2.984,0,0,1,0-4.127,2.929,2.929,0,0,1,4.127,0l21.914,21.856a2.936,2.936,0,0,1-2.035,5h-.116Z",
    transform: "translate(-52.106 10.61)",
    fill: "#c4d5df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2524",
    "data-name": "Path 2524",
    d: "M162.456,111.8a2.878,2.878,0,0,1-2.906-2.906,2.727,2.727,0,0,1,.872-2.034l21.739-21.739a2.984,2.984,0,0,1,4.127,0,2.929,2.929,0,0,1,0,4.127l-21.739,21.739a2.96,2.96,0,0,1-2.034.872h0Z",
    transform: "translate(-52.19 -50.589)",
    fill: "#c4d5df"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 37.724,
    cy: 37.724,
    rx: 37.724,
    ry: 37.724,
    transform: "translate(46.443 46.734)",
    fill: "#ffe080"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 23.192,
    cy: 23.193,
    rx: 23.192,
    ry: 23.193,
    transform: "translate(0.058 0.349)",
    fill: "#94d8e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 23.192,
    cy: 23.193,
    rx: 23.192,
    ry: 23.193,
    transform: "translate(0.058 122.182)",
    fill: "#b9f6d3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124",
    transform: "translate(0 3.197)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 14.532,
    cy: 14.532,
    rx: 14.532,
    ry: 14.532,
    transform: "translate(0 66.729)",
    fill: "#fbb540"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 14.532,
    cy: 14.532,
    rx: 14.532,
    ry: 14.532,
    transform: "translate(139.271 66.729)",
    fill: "#fbb540"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 11.625,
    cy: 11.625,
    rx: 11.625,
    ry: 11.625,
    transform: "translate(72.542 139.271)",
    fill: "#fbb540"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 11.625,
    cy: 11.625,
    rx: 11.625,
    ry: 11.625,
    transform: "translate(72.542)",
    fill: "#fbb540"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 23.192,
    cy: 23.193,
    rx: 23.192,
    ry: 23.193,
    transform: "translate(121.891)",
    fill: "#ff6e6e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 12.672,
    cy: 12.672,
    rx: 12.672,
    ry: 12.672,
    transform: "translate(72.426 63.3)",
    fill: "#fbb540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2525",
    "data-name": "Path 2525",
    d: "M181.666,93.74H164.752a12.7,12.7,0,0,0-12.672,12.672v1.046a33.825,33.825,0,0,0,42.258,0v-1.046A12.7,12.7,0,0,0,181.666,93.74Z",
    transform: "translate(-88.141 -5.097)",
    fill: "#fbb540"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 23.192,
    cy: 23.193,
    rx: 23.192,
    ry: 23.193,
    transform: "translate(121.891 122.182)",
    fill: "#ff9ba6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2526",
    "data-name": "Path 2526",
    d: "M150.166,113.832a6.351,6.351,0,0,1,6.336,6.336,6.193,6.193,0,0,1-4.592,6.045c-.174,0-.349.232-.349.407v1.163a1.457,1.457,0,0,1-1.337,1.453,1.391,1.391,0,0,1-1.453-1.4v-1.221s-.116-.349-.349-.407a6.311,6.311,0,0,1-4.592-6.045,1.457,1.457,0,0,1,1.337-1.453,1.427,1.427,0,0,1,1.453,1.4,3.521,3.521,0,0,0,7.033.232,3.532,3.532,0,0,0-3.488-3.778,6.351,6.351,0,0,1-6.336-6.336,6.193,6.193,0,0,1,4.592-6.045c.174,0,.349-.232.349-.407v-1.163a1.457,1.457,0,0,1,1.337-1.453,1.391,1.391,0,0,1,1.453,1.4v1.221s.116.349.349.407a6.311,6.311,0,0,1,4.592,6.045,1.457,1.457,0,0,1-1.337,1.453,1.427,1.427,0,0,1-1.453-1.4,3.521,3.521,0,0,0-7.033-.232,3.532,3.532,0,0,0,3.488,3.778Zm0,0a6.351,6.351,0,0,1,6.336,6.336,6.193,6.193,0,0,1-4.592,6.045c-.174,0-.349.232-.349.407v1.163a1.457,1.457,0,0,1-1.337,1.453,1.391,1.391,0,0,1-1.453-1.4v-1.221s-.116-.349-.349-.407a6.311,6.311,0,0,1-4.592-6.045,1.457,1.457,0,0,1,1.337-1.453,1.427,1.427,0,0,1,1.453,1.4,3.521,3.521,0,0,0,7.033.232,3.532,3.532,0,0,0-3.488-3.778,6.351,6.351,0,0,1-6.336-6.336,6.193,6.193,0,0,1,4.592-6.045c.174,0,.349-.232.349-.407v-1.163a1.457,1.457,0,0,1,1.337-1.453,1.391,1.391,0,0,1,1.453,1.4v1.221s.116.349.349.407a6.311,6.311,0,0,1,4.592,6.045,1.457,1.457,0,0,1-1.337,1.453,1.427,1.427,0,0,1-1.453-1.4,3.521,3.521,0,0,0-7.033-.232,3.532,3.532,0,0,0,3.488,3.778Z",
    transform: "translate(-127.845 30.613)",
    fill: "#5a9473"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2527",
    "data-name": "Path 2527",
    d: "M178.018,80.97h-7.5v6.22H164.3v7.5h6.22v6.22h7.5v-6.22h6.22v-7.5h-6.22Z",
    transform: "translate(-29.33 -66.555)",
    fill: "#c73636",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2528",
    "data-name": "Path 2528",
    d: "M165.91,91.14a1.061,1.061,0,0,0-.116-1.569l-10.4-9.068a1.316,1.316,0,0,0-1.686,0l-10.4,9.533a1.057,1.057,0,0,0,0,1.569l.232.291a1.112,1.112,0,0,0,1.569.116l.756-.7v10.23a1.166,1.166,0,0,0,1.163,1.163h4.069a1.166,1.166,0,0,0,1.163-1.163v-7.15h5.173v7.15a1.056,1.056,0,0,0,1.046,1.1h4.3a1.166,1.166,0,0,0,1.163-1.163V91.43a4.911,4.911,0,0,1,.465.407c.291.232.814,0,1.221-.407l.291-.349Z",
    transform: "translate(-132.08 -70.272)",
    fill: "#5d939e"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5",
    transform: "translate(130.654 132.747)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2529",
    "data-name": "Path 2529",
    d: "M177.034,108.8a3.953,3.953,0,0,1-3.72,0l-8.428-5.173s-.756-.465-.756.581v5.173c0,2.732,4.941,5.638,11.044,5.638s11.044-2.906,11.044-5.638v-5.464c0-.872-.523-.407-.523-.407l-8.6,5.29Z",
    transform: "translate(-160.802 -91.408)",
    fill: "#b84d5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2530",
    "data-name": "Path 2530",
    d: "M191.938,109.48a.79.79,0,0,0,0-1.453l-12.788-6.394a2.367,2.367,0,0,0-2.325,0l-12.788,6.394a.79.79,0,0,0,0,1.453l12.788,7.847a2.367,2.367,0,0,0,2.325,0",
    transform: "translate(-163.558 -101.327)",
    fill: "#b84d5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2531",
    "data-name": "Path 2531",
    d: "M170.131,112.159V103.5s0-.407-.232-.291a6.924,6.924,0,0,0-.872.523.861.861,0,0,0-.174.523v7.905l-.116.174a1.444,1.444,0,0,0-.756,1.279,1.511,1.511,0,1,0,3.022,0,1.38,1.38,0,0,0-.756-1.279.215.215,0,0,1-.116-.174Z",
    transform: "translate(-142.273 -92.381)",
    fill: "#b84d5a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMember);
export default __webpack_public_path__ + "static/media/member.607b51f4c4517ebc2c9c4163bc96763b.svg";
export { ForwardRef as ReactComponent };